import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {WorkHistoryNotesService} from '../../../../domain/model/work/work-history-notes/work-history-notes.service';
import {WorkHistoryNotes} from '../../../../domain/model/work/work-history-notes/work-history-notes.model';


@Component({
    template: require('./work-history-notes-screen.component.html')
})
export class WorkHistoryNotesScreenComponent {

    constructor(readonly modelService: WorkHistoryNotesService) {
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    stepScreenModel = new StepScreenModel<WorkHistoryNotes>({
        initialDataModel: new WorkHistoryNotes(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.modelService.getCurrentUserModel();
        },
        _submitDataFn: (model: WorkHistoryNotes) => {
            return this.modelService.updateCurrentUserModel(model);
        }
    });

    get model(): WorkHistoryNotes {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/steps/work-history-notes/work-history-notes-screen.component.ts